import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Shield, Award, TrendingUp } from "lucide-react";

const ViopSection = () => {
  return (
    <section className="relative overflow-hidden">
      <div
        className="absolute inset-0"
        style={{
          background:
            "linear-gradient(180deg, #5a85c4 0%, #3768b3 45%, #1c4d9c 100%)",
        }}
      />
      <div
        className="absolute inset-0 opacity-20"
        style={{
          backgroundImage:
            "radial-gradient(circle at 80% 30%, white 1px, transparent 1px), radial-gradient(circle at 20% 70%, white 1px, transparent 1px)",
          backgroundSize: "40px 40px, 60px 60px",
        }}
      />

      <div className="relative max-w-[1280px] mx-auto px-4 py-20 grid lg:grid-cols-2 gap-12 items-center text-white">
        <div>
          <h2 className="text-5xl md:text-6xl font-bold mb-6">VİOP</h2>
          <p className="text-lg leading-relaxed mb-4 text-white/95">
            Acar Menkul, Vadeli İşlem Piyasası'nda da uygun komisyon oranları,
            uzman kadrosu ve ücretsiz eğitimleriyle yatırımcıların yanında!
          </p>
          <p className="text-white/90 mb-7">
            VİOP Başlangıç Teminatları ve Kaldıraç Oranları için tıklayın.
          </p>
          <Link
            to="/hizmetlerimiz/viop"
            className="inline-flex items-center gap-2 px-6 py-3 border-2 border-white rounded-md font-semibold hover:bg-white hover:text-[#1c4d9c] transition"
          >
            Teminat Oranları
            <ArrowRight className="w-4 h-4" />
          </Link>

          <div className="grid grid-cols-3 gap-4 mt-10">
            {[
              { icon: Shield, label: "Güvenli İşlem" },
              { icon: Award, label: "Düşük Komisyon" },
              { icon: TrendingUp, label: "Yüksek Kaldıraç" },
            ].map((f, i) => (
              <div
                key={i}
                className="bg-white/10 backdrop-blur-sm rounded-lg p-4 border border-white/20"
              >
                <f.icon className="w-6 h-6 mb-2 text-white" />
                <p className="text-sm font-medium">{f.label}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Illustration */}
        <div className="relative hidden lg:block">
          <ViopIllustration />
        </div>
      </div>
    </section>
  );
};

const ViopIllustration = () => (
  <svg viewBox="0 0 500 400" className="w-full h-auto" fill="none">
    <circle cx="250" cy="200" r="160" fill="white" fillOpacity="0.08" />
    <circle cx="250" cy="200" r="120" fill="white" fillOpacity="0.1" />
    {/* main panel */}
    <rect x="170" y="140" width="200" height="120" rx="8" fill="white" />
    <rect x="180" y="155" width="60" height="6" rx="3" fill="#f59e0b" />
    <rect x="180" y="170" width="40" height="4" rx="2" fill="#cbd5e1" />
    {/* chart line */}
    <polyline
      points="180,240 210,220 240,225 270,200 300,210 330,175 360,185"
      stroke="#1c4d9c"
      strokeWidth="3"
      fill="none"
    />
    <circle cx="360" cy="185" r="5" fill="#1c4d9c" />
    {/* arrow up right */}
    <path d="M380 145 L430 95 M430 95 L430 120 M430 95 L405 95" stroke="#22c55e" strokeWidth="5" strokeLinecap="round" />
    {/* arrow down */}
    <path d="M130 200 L130 270 M130 270 L115 255 M130 270 L145 255" stroke="#ef4444" strokeWidth="5" strokeLinecap="round" />
    {/* small panel bottom */}
    <rect x="130" y="290" width="80" height="40" rx="6" fill="#ef4444" />
    <circle cx="150" cy="310" r="8" fill="white" />
    <rect x="165" y="305" width="35" height="4" rx="2" fill="white" />
    <rect x="165" y="313" width="25" height="3" rx="1.5" fill="white" fillOpacity="0.7" />
    {/* small panel top */}
    <rect x="280" y="90" width="80" height="40" rx="6" fill="#10b981" />
    <circle cx="300" cy="110" r="8" fill="white" />
    <rect x="315" y="105" width="35" height="4" rx="2" fill="white" />
    <rect x="315" y="113" width="25" height="3" rx="1.5" fill="white" fillOpacity="0.7" />
    {/* plus signs */}
    <text x="80" y="100" fill="#ef4444" fontSize="30" fontWeight="bold">+</text>
    <text x="420" y="320" fill="#22c55e" fontSize="30" fontWeight="bold">+</text>
    <text x="60" y="330" fill="#06b6d4" fontSize="24" fontWeight="bold">+</text>
    {/* paper plane */}
    <path d="M390 240 L460 220 L420 270 L420 250 L390 240Z" fill="white" fillOpacity="0.85" />
  </svg>
);

export default ViopSection;
